import styled from 'styled-components';

const ParentContainer = styled.div`
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.25);
`;

const ProgressContainer = styled.div`
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export { ParentContainer, ProgressContainer };
